import { render, staticRenderFns } from "./UtilidadVentas.vue?vue&type=template&id=7d61c7ff&"
import script from "./UtilidadVentas.vue?vue&type=script&lang=js&"
export * from "./UtilidadVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports